<template>
    <div class="h-24 rounded-lg box p-2 mt-2" @click="check">
        <div class="header flex justify-between">
            <div class="flex self-start h-auto w-auto">
                <slot name="input">
                    <vs-checkbox v-model="isChecked" :vs-value="vsValue" v-if="type === 'checkbox'"></vs-checkbox>
                    <vs-radio v-model="currentValue" :vs-value="vsValue" v-if="type === 'radio'"></vs-radio>
                </slot>
            </div>
            <span class="font-bold text-right">
                <slot name="title"></slot>
            </span>
        </div>
        <slot name="description"></slot>
    </div>
</template>

<script>
    export default {
        name: 'inputBox',
        props: {
            type: String,
            label: String,
            checked: Boolean,
            text: String,
            index: Number,
            value: '',
            "vsValue": null
        },

        data () {
            return {
                currentValue: null,
                isChecked: false
            }
        },

        methods: {
            check()
            {
                if (typeof this.value === "object" && this.value !== null) {
                    if (!this.isChecked) {
                        this.$emit('input', [...this.value, this.vsValue]);
                    } else {
                        this.$emit('input', this.value.filter(value => value !== this.vsValue));
                    }
                } else {
                    this.currentValue = this.vsValue;
                    this.$emit('input', this.currentValue)
                }

            }
        },

        created () {
            if (typeof this.value === "object" && this.value !== null) {
                this.isChecked = this.value.includes(this.vsValue);
            } else {
                this.isChecked = this.vsValue === this.value;
                if (this.isChecked) {
                    this.currentValue = this.vsValue;
                }
            }

        },

        watch: {
            value (newValue, oldValue) {
                this.currentValue = this.value;
                if (typeof this.value === "object" && this.value !== null) {
                    this.isChecked = this.value.includes(this.vsValue);
                } else {
                    this.isChecked = this.vsValue === this.value;
                }
            }
        },
    };
</script>

<style scoped>
    .box {
        border: 1px #ccc solid;
    }
</style>
